module.exports = "/images/group_events_grey.png?df058e94bba0f64d564f038162b1f24c";